import { NavLink } from 'react-router-dom';
import { Briefcase, Home, MessageCircle, Search, User } from 'lucide-react';
import { useAuth } from '../auth/AuthContext.tsx';
import { useUnreadCount } from '../messages.ts';

export function BottomNav() {
  const { user } = useAuth();
  const unread = useUnreadCount(Boolean(user));
  if (!user) return null;

  const items =
    user.role === 'EXTRA'
      ? [
          { to: '/extra', label: 'Missions', icon: Home },
          { to: '/extra/activite', label: 'Activité', icon: Briefcase },
          { to: '/extra/messages', label: 'Messages', icon: MessageCircle },
          { to: '/extra/profile', label: 'Profil', icon: User },
        ]
      : [
          { to: '/resto', label: 'Accueil', icon: Home },
          { to: '/resto/extras', label: 'Extras', icon: Search },
          { to: '/resto/messages', label: 'Messages', icon: MessageCircle },
        ];

  return (
    <nav className="bottom-nav">
      {items.map(({ to, label, icon: Icon }) => (
        <NavLink key={to} to={to} end={to !== '/extra/activite' && !to.endsWith('/messages')} className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}>
          <span style={{ position: 'relative', display: 'inline-flex' }}>
            <Icon size={20} strokeWidth={2.2} />
            {to.endsWith('/messages') && unread > 0 && (
              <span aria-label={`${unread} message${unread > 1 ? 's' : ''} non lu${unread > 1 ? 's' : ''}`} style={{ position: 'absolute', top: -6, right: -10, minWidth: 16, height: 16, padding: '0 4px', borderRadius: 8, background: 'var(--danger)', color: '#fff', fontSize: 10, fontWeight: 800, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                {unread > 9 ? '9+' : unread}
              </span>
            )}
          </span>
          {label}
        </NavLink>
      ))}
    </nav>
  );
}
